export default "__VITE_ASSET__BvLGXQGj__"